// SubmissionConfirmation.jsx
import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import MyQuill from "../quill/MyQuill";
import axios from "axios";
import { API_ENDPOINT } from "../utils/constants";

const SubmissionConfirmation = ({
  prevHeader,
  setPrevHeader,
  prevFooter,
  setPrevFooter,
  initialBadgeBg,
  appId,
}) => {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(initialBadgeBg || ""); // ← fix: separate preview state

  // Revoke old object URL to avoid memory leaks
  useEffect(() => {
    return () => {
      if (previewUrl && previewUrl.startsWith("blob:")) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const handleFileChange = (event) => {
    const selected = event.target.files?.[0];
    if (!selected) return;

    setFile(selected);
    // ↓ create a local blob URL so the <img> can show it immediately
    const objectUrl = URL.createObjectURL(selected);
    setPreviewUrl(objectUrl);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await axios.post(
        `${API_ENDPOINT}event/upload-badge-bg`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            dbauth: appId,
          },
        }
      );
      // ↓ after successful upload, switch preview to the real server URL
      if (response.data?.url) {
        setPreviewUrl(response.data.url);
      }
      setFile(null); // reset file input
      alert("File uploaded successfully!");
    } catch (error) {
      console.error("Upload error:", error);
      alert("File upload failed.");
    }
  };

  return (
    <div>
      <Typography variant="h6" textAlign="center">
        Submission Confirmation
      </Typography>

      <Box mt={1}>
        <Typography variant="h6">Top Header Desc</Typography>
        <MyQuill value={prevHeader} onChange={setPrevHeader} />

        <Typography my={3} variant="h5">
          ***[Badge will appear here]***
        </Typography>

        <Box textAlign="center" my={1}>
          {/* ↓ previewUrl drives the <img> — updates on file select AND after upload */}
          {previewUrl ? (
            <img
              src={previewUrl}
              alt="Badge preview"
              style={{
                display: "block",
                height: "192px",
                marginLeft: "auto",
                marginRight: "auto",
                objectFit: "contain",
                border: "1px solid #eee",
                borderRadius: 4,
              }}
            />
          ) : (
            <Box
              sx={{
                height: 192,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px dashed #ccc",
                borderRadius: 1,
                color: "text.secondary",
              }}
            >
              No image selected
            </Box>
          )}

          <Box mt={1}>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
              id="upload-badge-bg"
            />
            <label htmlFor="upload-badge-bg">
              <Button component="span" variant="outlined" size="small">
                Select Image
              </Button>
            </label>

            <Button
              sx={{ mt: 1, ml: 1, py: 0.6 }}
              variant="outlined"
              size="small"
              onClick={handleUpload}
              disabled={!file} // only enabled when a new file is staged
            >
              Save Badge Bg
            </Button>
          </Box>
        </Box>

        <Typography variant="h6">Bottom Header Desc</Typography>
        <MyQuill value={prevFooter} onChange={setPrevFooter} />
      </Box>
    </div>
  );
};

export default SubmissionConfirmation;
